<template>
  <order-state-history-item :item="item">
    <template #title>
      Оплата отменена
    </template>
    <template #icon>
      <div class="os-history-item__source_icon history-item-icon-wrapper">
        <img class="history-item-icon" src="img/icons/order-history/cancel.svg" alt="cancel" />
      </div>
    </template>
    <template #content>
      {{ description }}
    </template>
  </order-state-history-item>
</template>

<script>
  import PaymentType from '@/models/enums/PaymentType'
  import OrderStateHistoryItem from '../OrderStateHistoryItem.vue'
  import RefundType from '@/models/enums/RefundType'
  import { mapState } from 'vuex'

  export default {
    name: 'HistoryItemTypePaymentCancel',
    components: { OrderStateHistoryItem },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        currentEditOrder: state => state.orders.currentEditOrder,
      }),
      description () {
        const paymentType = PaymentType.getNameWithPlace(this.item.payment.type, this.currentEditOrder?.deliveryType, this.item.payment.mode)
        const amount = this.$options.filters.amountWithCurrency(this.item.payment.totalRub)
        const refundType = RefundType.getName(this.item.payment.refundType).toLowerCase()

        return `${paymentType}, ${amount}. Возвращён ${refundType}.`
      },
    },
  }
</script>

<style lang="less" scoped>
.history-item-icon {
  width: 22px !important;
  height: 22px !important;

  &-wrapper {
    margin-right: 0;
  }
}
</style>
